export default __webpack_public_path__ + "static/media/arr1.a7213c0d.svg";